import React, { Component } from 'react';
import {
  Button,Dialog,DialogActions,DialogContent,DialogTitle,Paper,Table,TableBody,TableCell,TableContainer,TableHead,TableRow,TextField,Typography,Box,Collapse,IconButton,Alert,
} from '@mui/material';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import CloseIcon from '@mui/icons-material/Close';
import TablePagination from '@mui/material/TablePagination';
import axios from 'axios';
import { Navigate  } from 'react-router-dom';
import Serverurl from './Apiurl';

export default class Bannermanagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      banners: [],
      totalItems: 0,
      page: 0,
      rowsPerPage: 5,
      itemsPerPageOptions: [5, 10, 20],
    };
    this.bannerDialogRef = React.createRef();
  }

  componentDidMount(){ 
   document.title = "Prep for Sale- Staff Management";
		if(localStorage.getItem("DCuserid")==null)
		  {
		   this.setState({
            logredirect: true,
			pagename:'/'
          })
		  }
  this.fetchBanners();
  }

  fetchBanners = () => {
    axios.get(`${Serverurl}banner/getall?page=${this.state.page}&limit=${this.state.rowsPerPage}`)
      .then((res) => {
        const { data, totalItems } = res.data;
        this.setState({ banners: data, totalItems });
      });
  };

  handleDelete = (bn_id) => {
    confirmAlert({
      title: 'Confirm Delete',
      message: 'Are you sure you want to delete this banner?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            axios.delete(`${Serverurl}banner/bannerdelete/${bn_id}`).then(() => this.fetchBanners());
          },
        },
        { label: 'No' },
      ],
    });
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, this.fetchBanners);
  };

  handleChangeRowsPerPage = (event) => {
    const newRows = parseInt(event.target.value, 10);
    this.setState({ rowsPerPage: newRows, page: 0 }, this.fetchBanners);
  };

  BannerAddbox = (banner = null) => { 
    this.bannerDialogRef.current?.handleClickOpen(banner); 
  };

  render() {
	   if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />
    } 
    return (
      <>
	  	  <div className="maincontentDiv">
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Typography className="contentHeading" variant="h5">Banners</Typography>
          <Button
		  style={{
    marginRight: '20px',
    marginTop: '15px'
}}
		  size="small"
            variant="contained"
            className="frmPrimarybtn"
            onClick={() => this.BannerAddbox(null)} 
            startIcon={<AddIcon />}
          >
            Add
          </Button>
        </Box>

        <Bannerdialog ref={this.bannerDialogRef} onSuccess={this.fetchBanners} /> {/* Banner Dialog */}

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Title</TableCell>
                <TableCell>Image</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.banners.map((banner) => (
                <TableRow key={banner.bn_id}>
                  <TableCell>{banner.bn_title}</TableCell>
                  <TableCell>
                    {banner.bn_image ? (
                      <img
                        src={`${Serverurl}uploads/${banner.bn_image}`}
                        alt={banner.bn_title}
                        width={120}
                        style={{ borderRadius: 4 }}
                      />
                    ) : (
                      <Typography variant="body2" color="textSecondary">No image</Typography>
                    )}
                  </TableCell>
                  <TableCell>
                    <Button
					size="small"
                      variant="contained"
                      className="frmPrimarybtn"
                      onClick={() => this.BannerAddbox(banner)} // Edit banner
                      endIcon={<EditIcon />}
                      sx={{ mr: 1 }}
                    >
                      Edit
                    </Button>
                    <Button
					size="small"
                      variant="contained"
                      className="frmSecondarybtn"
                      onClick={() => this.handleDelete(banner.bn_id)} // Delete banner
                      endIcon={<DeleteIcon />}
                    >
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          <TablePagination
            component="div"
            count={this.state.totalItems}
            page={this.state.page}
            onPageChange={this.handleChangePage}
            rowsPerPage={this.state.rowsPerPage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
            rowsPerPageOptions={this.state.itemsPerPageOptions}
          />
        </TableContainer></div>
      </>
    );
  }
}





class Bannerdialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bn_id: '',
      bn_title: '',
      bn_image: null,
      bn_imageUrl: '',
      isEditing: false,
      open: false,
      errormessage: '',
      validationErrors: {},
      erropen: false,  
    };
  }

  handleClickOpen = (banner = null) => {
    if (banner) {
      this.setState({
        bn_id: banner.bn_id,
        bn_title: banner.bn_title,
        bn_image: null,
        bn_imageUrl: banner.bn_image || '',
        isEditing: true,
        validationErrors: {},
        errormessage: '',
        open: true,
        erropen: false,  
      });
    } else {
      this.setState({
        bn_id: '',
        bn_title: '',
        bn_image: null,
        bn_imageUrl: '',
        isEditing: false,
        validationErrors: {},
        errormessage: '',
        open: true,
        erropen: false,  
      });
    }
  };

  handleCloseDialog = () => {
    this.setState({
      bn_id: '',
      bn_title: '',
      bn_image: null,
      bn_imageUrl: '',
      isEditing: false,
      validationErrors: {},
      errormessage: '',
      open: false,
      erropen: false,  
    });
  };

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleFileChange = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      const allowedTypes = ['image/jpeg', 'image/png'];

      if (!allowedTypes.includes(file.type)) {
        this.setState({
          errormessage: 'Only JPG and PNG formats are allowed.',
          erropen: true,  
          bn_image: null,
          bn_imageUrl: '',
        });
        return;
      }

      this.setState({
        bn_image: file,
        bn_imageUrl: URL.createObjectURL(file),
        errormessage: '',
        erropen: false, 
      });
    }
  };

  validateForm = () => {
    const errors = {};
    if (!this.state.bn_title.trim()) errors.bn_title = 'Title is required';
    if (!this.state.isEditing && !this.state.bn_image) errors.bn_image = 'Please upload an image';
    if (this.state.bn_image && !['image/jpeg', 'image/png'].includes(this.state.bn_image.type)) {
      errors.bn_image = 'Only JPG and PNG formats are allowed';
    }

    if (Object.keys(errors).length > 0) {
      this.setState({
        validationErrors: errors,
        errormessage: errors.bn_title || errors.bn_image,
        erropen: true,  // Show error message when validation fails
        open: true,
      });
      return false;
    }

    this.setState({ validationErrors: {}, errormessage: '', erropen: false });
    return true;
  };

  handleSubmit = () => {
    if (!this.validateForm()) return;

    const formData = new FormData();
    formData.append('bn_title', this.state.bn_title);
    if (this.state.bn_image) formData.append('bn_image', this.state.bn_image);

    const config = { headers: { 'Content-Type': 'multipart/form-data' } };

let request;
 if( this.state.isEditing){
 request= axios.put(`${Serverurl}banner/bannerupdate/${this.state.bn_id}`, formData, config);}else{
      request= axios.post(Serverurl+'banner/bannerinsert', formData, config);
 }
    request
      .then(() => {
        this.props.onSuccess(); 
        this.handleCloseDialog();
      })
      .catch((err) => {
        this.setState({
          errormessage: err.response?.data?.message || 'Error occurred',
          open: true,
          erropen: true,  
        });
      });
  };

  render() {
    return (
      <Dialog open={this.state.open} onClose={this.handleCloseDialog} maxWidth="sm" fullWidth>
        <DialogTitle>{this.state.isEditing ? 'Banner' : 'Banner'}</DialogTitle>
        <DialogContent>
          <Collapse in={this.state.erropen}>
            <Alert severity="error" action={<IconButton onClick={() => this.setState({ erropen: false })}><CloseIcon /></IconButton>}>
              {this.state.errormessage}
            </Alert>
          </Collapse>
<p>Title<span className="validation"> * </span></p>
          <TextField
            name="bn_title"
          placeholder="Enter Title"
            fullWidth
            value={this.state.bn_title}
            onChange={this.handleInputChange}
			 inputProps={{ maxLength: 150 }}
            margin="normal"
            size="small"
          />

          <Box mt={2} mb={2}>
            <Button variant="contained" className="frmPrimarybtn" component="label" startIcon={<UploadFileIcon />}>
              Upload Image
              <input type="file" accept=".jpg,.jpeg,.png" hidden onChange={this.handleFileChange} />
            </Button>
          </Box>

          {this.state.bn_imageUrl && (
            <Box mb={2}>
              <Typography variant="subtitle2">Preview:</Typography>
              <img
                src={this.state.bn_imageUrl.startsWith('blob:') ? this.state.bn_imageUrl : `${Serverurl}uploads/${this.state.bn_imageUrl}`}
                alt="Banner preview"
                width={150}
                style={{ borderRadius: 4 }}
              />
            </Box>
          )}
        </DialogContent>

  <DialogActions sx={{ display: "flex", justifyContent: "space-between" }}>
  <Button className="frmSecondarybtn" onClick={this.handleCloseDialog} variant="outlined" color="inherit">
            Cancel
          </Button>
          <Button className="frmPrimarybtn" onClick={this.handleSubmit} variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
